<template>
  <section>
    <el-col :span="6" class="toolbar">
      <el-input placeholder="" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading"
              @expand="expand"
              :row-key="getRowKeys"
              :expand-row-keys="expands">
 
      <el-table-column
        label="标题"
        prop="title"
        align="center">
      </el-table-column>

      <el-table-column
        label="商品ID"
        prop="proid"
        align="center">
      </el-table-column>
         <el-table-column
        label="店铺ID"
        prop="dianpuid"
        align="center">
      </el-table-column>
      <el-table-column
        label="模式"
        prop="mode"
        align="center">
          <template scope="scope">
          <div>{{spiderMode[scope.row.mode]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="createtime"
        align="center">
      </el-table-column>
      <el-table-column
        label="爬虫状态"
        prop="status"
        align="center">
        <template scope="scope">
          <div>{{spiderStatus[scope.row.status]}}</div>
        </template>
      </el-table-column>
      
      <el-table-column
        label="操作"
        prop="event_unique_key"
        align="center">
        <template scope="scope">
          <el-button  type="primary" size="small" @click="setSpider(scope.row._id, 1)">失效</el-button>
          <el-button  type="danger" size="small" @click="setSpider(scope.row._id, 2)">删除</el-button>
          <el-button  type="info" size="small" @click="setSpider(scope.row._id, 0)">恢复</el-button>
        </template>
      </el-table-column>
    </el-table>


    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

  </section>
</template>

<script>
  import config from '../../config';
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:30,
        listLoading: false,
        expands: [],
        getRowKeys(row) {
          return row._id;
        },
        query: '',
        spiderStatus: basicdata.spiderStatus,
        spiderMode: basicdata.spiderMode,
      
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        let url = config.api_url + '/spider/page'
        this.$axios.post(url, {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
  	
      //推荐
      setSpider(id, isrecommend) {
        this.$axios.post(config.api_url + '/spider/status', {
          id: id,
          status: isrecommend
        }).then(response => {
          if(response.data.state) {
            this.$message({
              message: '成功!',
              type: 'success'
            });
            this.search();
          } else {
            this.$message({
              message: '失败，请联系管理员',
              type: 'error'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '异常，请联系管理员',
            type: 'error'
          });
        });
      }
      },
    created() {
      this.search();
    },
  }
</script>

<style scoped>
    .rightsearch{
        float: right;
    }
    .piclist {
      width: 100%;
    }
    .piclist>a {
      width: 30%;
      float: left;
      padding: 0 10px 10px 10px;
    }
    .piclist>a>img {
     width: 100%;
     height: 100px;
    }
</style>


// WEBPACK FOOTER //
// spider.vue?1c5fadf0